<template>
  <main class="main">
    <section class="hero grid section">
      <div class="hero__video">
        <video controls src="https://ipssoma-storage.s3.eu-west-1.amazonaws.com/curso diplomado/6/537/class/whatsapp_video_2022-12-27_at_70800_pm.mp4"></video>
      </div>
      <div class="hero__information">
        <div class="hero__titles">
          <h2>Programa de Estudio <strong>Supervisor SSOMA</strong></h2>
          <h1>SUPERVISOR EN SEGURIDAD, SALUD OCUPACIONAL Y MEDIO AMBIENTE.</h1>
          <h3>Bajo los estándares <strong>ISO 45001:2018 E ISO 14001:2015</strong></h3>
        </div>
        <ul class="hero__list">
          <li>Inicio de Clases: <span>Permanente.</span></li>
          <li>Duración: <span>4 meses.</span></li>
          <li>Turno: <span>Horario Flexible.</span></li>
          <li>Modalidad: <span>Virtual (App. Zoom) Tiempo Real.</span></li>
        </ul>
        <div class="hero__buttons">
          <a href="https://www.ipssoma.com/iniciar-sesion" class="button">¡Comprar el Programa!</a>
          <a href="#study" class="button button--2">Deseo saber más...</a>
        </div>
      </div>
      <div class="hero__cards">
        <div class="hero__card">
          <svg xmlns="http://www.w3.org/2000/svg" class="hero__icon" viewBox="0 0 24 24">
            <path
              d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM13 12H17V14H11V7H13V12Z">
            </path>
          </svg>
          <h4>HORARIO DE CLASES</h4>
          <span>Mar y Jue de <time datetime="20:00 - 22:00">20:00 - 22:00</time></span>
          <span>Sáb de Asesorías de <time datetime="13:00 - 14:00">13:00 - 14:00</time></span>
        </div>
        <div class="hero__card">
          <svg xmlns="http://www.w3.org/2000/svg" class="hero__icon" viewBox="0 0 24 24">
            <path
              d="M20.0049 8V5H4.00488V8H20.0049ZM20.0049 10H4.00488V19H20.0049V10ZM3.00488 3H21.0049C21.5572 3 22.0049 3.44772 22.0049 4V20C22.0049 20.5523 21.5572 21 21.0049 21H3.00488C2.4526 21 2.00488 20.5523 2.00488 20V4C2.00488 3.44772 2.4526 3 3.00488 3ZM11.0049 14H17.0049V16H6.50488L11.0049 11.5V14Z">
            </path>
          </svg>
          <h4>CERTIFICADO</h4>
          <span>Entrega de certificado digital verificable en web y formato físico, envío a nivel nacional por Olva Courier.</span>
        </div>
        <div class="hero__card">
          <svg xmlns="http://www.w3.org/2000/svg" class="hero__icon" viewBox="0 0 24 24">
            <path
              d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12H4C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C9.25022 4 6.82447 5.38734 5.38451 7.50024L8 7.5V9.5H2V3.5H4L3.99989 5.99918C5.82434 3.57075 8.72873 2 12 2ZM13 7L12.9998 11.585L16.2426 14.8284L14.8284 16.2426L10.9998 12.413L11 7H13Z">
            </path>
          </svg>
          <h4>TOTAL DE HORAS</h4>
          <span><time datetime="480 horas">480 horas </time>académicas/lectivas</span>
        </div>
        <div class="hero__card">
          <svg xmlns="http://www.w3.org/2000/svg" class="hero__icon" viewBox="0 0 24 24">
            <path
              d="M1 4H23V6H1V4ZM1 18H23V20H1V18ZM19.6217 14.9136L19.448 14.0436L17.4994 14.0435L17.1899 14.907L15.6275 14.9105C16.6316 12.5036 17.3767 10.7206 17.8628 9.56169C17.9898 9.25902 18.2156 9.10462 18.5482 9.10699C18.802 9.10888 19.2168 9.10912 19.7927 9.10771L21 14.9108L19.6217 14.9136ZM17.9376 12.8518H19.1936L18.7248 10.6715L17.9376 12.8518ZM7.87203 9.10561L9.44245 9.10764L7.01511 14.9136L5.42535 14.9129C4.88785 12.8424 4.49315 11.3073 4.24125 10.3076C4.16402 10.001 4.01042 9.787 3.71519 9.68577C3.45195 9.59551 3.01355 9.45594 2.4 9.26707V9.10771C3.54718 9.10757 4.38339 9.10757 4.90863 9.10771C5.34299 9.10784 5.59619 9.31703 5.67765 9.74655C5.75942 10.1779 5.96599 11.2743 6.29735 13.0359L7.87203 9.10561ZM11.5994 9.10765L10.3588 14.913L8.86434 14.9108C8.89383 14.7698 9.30682 12.8347 10.1033 9.10561L11.5994 9.10765ZM14.6307 9C15.0773 9 15.6405 9.13846 15.9652 9.26707L15.703 10.4706C15.41 10.3532 14.9284 10.1944 14.5228 10.2006C13.933 10.2097 13.569 10.4566 13.569 10.6936C13.569 11.0783 14.2015 11.272 14.8528 11.6929C15.5956 12.1729 15.6937 12.603 15.6845 13.0713C15.6739 14.0422 14.8528 15 13.12 15C12.3286 14.9882 12.0444 14.9219 11.3995 14.6936L11.6718 13.4376C12.3282 13.712 12.6066 13.7991 13.1675 13.7991C13.6816 13.7991 14.1229 13.5918 14.1267 13.2308C14.1294 12.974 13.972 12.847 13.395 12.5293C12.8181 12.2117 12.0095 11.7726 12.0199 10.8889C12.0332 9.75821 13.1066 9 14.6307 9Z">
            </path>
          </svg>
          <h4>MÉTODOS DE PAGOS</h4>
          <span>BCP - Sctotiabank</span>
          <span>BBVA - Banco de la Nación</span>
          <span>Yape - Plin - Tarjeta Débito/Crédito</span>
        </div>
      </div>
    </section>
    <section class="study" id="study">
      <div class="study__information">
        <h2 class="study__subtitle">Acerca del Programa de Estudio <strong>Supervisor SSOMA</strong></h2>
        <div class="study__tab-content">
        <ul class="study__tab">
          <li class="study__item items active-tab"><h3 class="study__title-tab">Descripción General</h3></li>
          <li v-for="(item,index) in lists" :key="index" class="study__item items"><h3 class="study__title-tab">{{ item }}</h3></li>
          <div class="line"></div>
          <div class="line--2"></div>
        </ul>
        <div class="study__content">
          <div class="study__content-information contents active-content">
            <dl>
              <dt>1. INTRODUCCIÓN:</dt>
              <dd>
                <p>En la actualidad, uno de los trabajos con mayor demanda y proyección del país es la <em>implantación del sistema de gestión <strong>SSOMA</strong></em>.</p>
                <p>Cada vez son más las empresas que desean <em>reducir los costos que se asocian a los accidentes laborales y a los impactos ambientales</em>.</p>
                <p>El <strong>SSOMA (Seguridad y Salud Ocupacional y Medio Ambiente)</strong> se encuentra entre los modelos de gestión más reconocidos del mundo.</p>
                <p>Una empresa elige implantarlo para cumplir con las <strong>normas de gestión de Seguridad y Salud en el Trabajo (ISO 45001:2018) y la Gestión Ambiental (ISO 14001:2015).</strong></p>
                <p>Es por eso por lo que la <em>Cámara Universitaria de Prevencionista</em> en alianza educativa con el <em>INSTITUTO PERUANO SSOMA SAC</em> han diseñado el Programa de Estudio Actualizado: <strong>SUPERVISOR EN SEGURIDAD Y SALUD OCUPACIONAL Y MEDIO AMBIENTE BAJO LOS ESTÁNDAR ISO 45001:2018 E ISO 14001:2015</strong> de <time datetime="480 horas">480 horas</time> académicas lectivas, para que aprendas a implementar eficaz y eficientemente el <strong>Sistema de Gestión SSOMA</strong> en tu organización, logrando obtener una mejor posición laboral.</p>
              </dd>
              <dt>2. OBJETIVO:</dt>
              <dd>
                <ul>
                  <li>- Conocer la normativa legal de obligatorio cumplimientos de <strong>SSOMA</strong>.</li>
                  <li>- Comprendery poseer capacidad crítica de las diferentes relaciones entre condiciones de trabajo y salud.</li>
                  <li>- Comprender los métodos experimentales de investigación que siver de base para la estructuración de las medidas preventivas.</li>
                  <li>- Desarrollar las actividades de formación e información a los trabajadores en materia preventiva.</li>
                  <li>- Conocer los sistema de notificación de accidentes de <em>trabajo y enfermedades profesionales, su normativa y su documentación</em>.</li>
                  <li>- Conocer, interpretar e implementar las <strong>normas ISO 45001:2018 E 14001:2015</strong>.</li>
                  <li>- <em>Reducir los costos que se asocian a los accidentes laborales y los impactos ambientales</em>.</li>
                </ul>
              </dd>
              <dt>3. DIRIGIDO A:</dt>
              <dd>
                <ul>
                  <li>- Profesionales,técnicos, bachilleres, estudiantes de educación superior, que buscan adquirir o ampliar sus conocimientos en <em>materia de <strong>gestión SSOMA</strong></em>.</li>
                  <li>- Público en general que desee adquirir o actualizar conocimientos en el área de <strong>Seguridad y Salud Ocupacional y Medio Ambiente</strong>.</li>
                </ul>
              </dd>
              <dt>4. METODOLOGÍA DE ESTUDIO:</dt>
              <dd>
                <em class="em--diferent">"Apostamos a la tecnología como la mejor alternativa para la capacitación y desarrollo profesional"</em>.
                <ul>
                  <li>- <em class="em--diferent-li"><b>Clases en vivio Vía Zoom:</b></em> Podrás acceder a todas nuestras clases y seminarios en tiempo real.</li>
                  <li>- <em class="em--diferent-li"><b>Plataforma de Estudio:</b></em> Nuestro campus virtural estará habilitado las 24 horas del día y los 7 días de la semana (horario flexible).</li>
                  <li>- <em class="em--diferent-li"><b>Evaluaciones:</b></em> Las realizarás en la plataforma de estudio, desde la comodidad de tu hogar.</li>
                </ul>
                <div class="button-download">
                  <a href="https://www.ipssoma.com/iniciar-sesion" class="button download-pdf">¡Comprar Ahora!</a>
                </div>
              </dd>
            </dl>
          </div>
          <div class="study__content-information contents">
            <dl>
              <dt>MÓDULO I: BASES LEGALES PARA LA GESTIÓN DE SEGURIDAD Y SALUD EN EL TRABAJO</dt>
              <dd>
                <ol>
                  <li>1.1. &nbsp;&nbsp;  <em>Conceptos Básicos sobre Seguridad y Salud en el Trabajo</em>.</li>
                  <li>1.2. &nbsp;&nbsp;  <em>Conceptos Básicos sobre Seguridad y Salud en el Trabajo-2/2</em>.</li>
                  <li>1.3. &nbsp;&nbsp;  <em>LEY 29783 Y Modificatorias-Normativa Legal y Fiscalización SUNAFIL</em>.</li>
                  <li>1.4. &nbsp;&nbsp;  <em>D.S. 005-2012-Reglamento de Ley 29783</em>.</li>
                  <li>1.5. &nbsp;&nbsp;  <em>Registros Obligatorios en SST</em>.</li>
                  <li>1.6. &nbsp;&nbsp;  <em>Exámenes Médicos Ocupacionales</em>.</li>
                  <li>1.7. &nbsp;&nbsp;  <em>Plan Anual de Seguridad y Salud en el Trabajo</em>.</li>
                  <li>1.8. &nbsp;&nbsp;  <em>Diagnóstico de Línea Base</em>.</li>
                  <li>1.9. &nbsp;&nbsp;  <em>Políticas, Objetivos Y Metas</em>.</li>
                  <li>1.10. &nbsp; <em>Reglamento Interno de SST-RISST</em>.</li>
                  <li>1.11. &nbsp; <em>Comité de SST</em>.</li>
                  <li>1.12. &nbsp; <em>IPERC</em>.</li>
                  <li>1.13. &nbsp; <em>Organización y Responsabilidades</em>.</li>
                  <li>1.14. &nbsp; <em>Programa Anual de SST</em>.</li>
                  <li>1.15. &nbsp; <em>Planificación de Actividades Preventivas</em>.</li>
                  <li>1.16. &nbsp; <em>Inspecciones Internas en SST</em>.</li>
                  <li>1.17. &nbsp; <em>Clientes, Sub-Contratos Y Proveedores</em>.</li>
                  <li>1.18. &nbsp; <em>Plan de Contingencia en SST</em>.</li>
                  <li>1.19. &nbsp; <em>Investigación de Accidentes en SST</em>.</li>
                  <li>1.20. &nbsp; <em>Auditorias OHSAS 18001</em>.</li>
                  <li>1.21. &nbsp; <em>Auditorias ISO 45001</em>.</li>
                  <li>1.22. &nbsp; <em>Estadísticas en SST</em>.</li>
                  <li>1.23. &nbsp; <em>Indicadores de SST</em>.</li>
                  <li>1.24. &nbsp; <em>Indicadores de SST-2/2</em>.</li>
                  <li>1.25. &nbsp; <em>Implementación del Plan de SST-Mantenimiento de Registros-Revisión del SGSTT</em>.</li>
                  <li>1.26. &nbsp; <em>Mapa de Riesgo</em>.</li>
                  <li>1.27. &nbsp; <em>Señalización y Colores</em>.</li>
                  <li>1.28. &nbsp; <em>EPP</em>.</li>
                  <li>1.29. &nbsp; <em>ATS</em>.</li>
                  <li>1.30. &nbsp; <em>PETS</em>.</li>
                  <li>1.31. &nbsp; <em>Implementación y Llenado de Formatos: ATS, PETS Y Checklist De EPP, Equipos y Herramientas</em>.</li>
                  <li>1.32. &nbsp; <em>Ergonomía</em>.</li>
                  <li>1.33. &nbsp; <em>Ergonomía - 2/2</em>.</li>
                  <li>1.34. &nbsp; <em>Higiene Ocupacional</em>.</li>
                  <li>1.35. &nbsp; <em>Seguridad Basada en el Comportamiento</em>.</li>
                </ol>
              </dd>
              <dt>MÓDULO II: SISTEMA DE GESTIÓN DE SST BAJO LA NORMA ISO 45001:2018</dt>
              <dd>
                <ol>
                  <li>2.1. &nbsp;&nbsp; <em>Introducción</em>.</li>
                  <li>2.2. &nbsp;&nbsp; <em>ISO 45001:2018</em>.</li>
                </ol>
              </dd>
              <dt>MÓDULO III: ESTRUCTURA DE LA NORMA ISO 45001:2018</dt>
              <dd>
                <ol>
                  <li>3.1. &nbsp;&nbsp; <em>ISO 45001:2018</em>-Análisis e Interpretación-1</li>
                  <li>3.2. &nbsp;&nbsp; <em>ISO 45001:2018</em>-Análisis e Interpretación-2</li>
                  <li>3.3. &nbsp;&nbsp; <em>ISO 45001:2018</em>-Análisis e Interpretación-3</li>
                  <li>3.4. &nbsp;&nbsp; <em>ISO 45001:2018</em>-Análisis e Interpretación-4</li>
                  <li>3.5. &nbsp;&nbsp; <em>ISO 45001:2018</em>-Análisis e Interpretación-5</li>
                  <li>3.6. &nbsp;&nbsp; <em>ISO 45001:2018</em>-Análisis e Interpretación-6</li>
                </ol>
              </dd>
              <dt>MÓDULO IV: COMO IMPLEMENTAR ISO 45001:2018</dt>
              <dd>
                <ol>
                  <li>4.1 &nbsp;&nbsp; <em>ISO 45001:2018-Implantación</em>.</li>
                </ol>
              </dd>
              <dt>MÓDULO V: NUEVAS DIRECTRICES ISO/PAS 45005:2020</dt>
              <dd>
                <ol>
                  <li>5.1. &nbsp;&nbsp; <em>Nuevas Directrices-ISO/PAS 45005:2020</em>-1.</li>
                  <li>5.2. &nbsp;&nbsp; <em>Nuevas Directrices-ISO/PAS 45005:2020</em>-2.</li>
                </ol>
              </dd>
              <dt>MÓDULO VI: SISTEMA DE GÉSTION AMBIENTAL BAJO LA NORMA ISO 14001:2015</dt>
              <dd>
                <ol>
                  <li>6.1. &nbsp;&nbsp; <em>ISO 14001:2015</em>-Análisis E Implantación-1.</li>
                  <li>6.2. &nbsp;&nbsp; <em>ISO 14001:2015</em>-Análisis E Implantación-2.</li>
                  <li>6.3. &nbsp;&nbsp; <em>ISO 14001:2015</em>-Análisis E Implantación-3.</li>
                </ol>
              </dd>
              <div class="button-download">
                <a href="https://www.ipssoma.com/iniciar-sesion" class="button download-pdf">¡Comprar Ahora!</a>
              </div>
            </dl>
          </div>
          <!-- <div class="study__content-information contents">
            <div class="study__teams">
              <div class="study__team">
                <div class="team__img">
                  <img src="../../../assets/team-1.webp" alt="Emilio Lopez">
                </div>
                <div class="team__informartion">
                  <h4>Emilio Lopez</h4>
                  <p>Ing. Industrial y de Gestión Empresarial CIP N° 200314</p>
                  <div class="team__icons">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M14 13.5H16.5L17.5 9.5H14V7.5C14 6.47062 14 5.5 16 5.5H17.5V2.1401C17.1743 2.09685 15.943 2 14.6429 2C11.9284 2 10 3.65686 10 6.69971V9.5H7V13.5H10V22H14V13.5Z"></path></svg>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M13.0281 2.00098C14.1535 2.00284 14.7238 2.00879 15.2166 2.02346L15.4107 2.02981C15.6349 2.03778 15.8561 2.04778 16.1228 2.06028C17.1869 2.10944 17.9128 2.27778 18.5503 2.52528C19.2094 2.77944 19.7661 3.12278 20.3219 3.67861C20.8769 4.23444 21.2203 4.79278 21.4753 5.45028C21.7219 6.08694 21.8903 6.81361 21.9403 7.87778C21.9522 8.14444 21.9618 8.36564 21.9697 8.58989L21.976 8.78397C21.9906 9.27672 21.9973 9.8471 21.9994 10.9725L22.0002 11.7182C22.0003 11.8093 22.0003 11.9033 22.0003 12.0003L22.0002 12.2824L21.9996 13.0281C21.9977 14.1535 21.9918 14.7238 21.9771 15.2166L21.9707 15.4107C21.9628 15.6349 21.9528 15.8561 21.9403 16.1228C21.8911 17.1869 21.7219 17.9128 21.4753 18.5503C21.2211 19.2094 20.8769 19.7661 20.3219 20.3219C19.7661 20.8769 19.2069 21.2203 18.5503 21.4753C17.9128 21.7219 17.1869 21.8903 16.1228 21.9403C15.8561 21.9522 15.6349 21.9618 15.4107 21.9697L15.2166 21.976C14.7238 21.9906 14.1535 21.9973 13.0281 21.9994L12.2824 22.0002C12.1913 22.0003 12.0973 22.0003 12.0003 22.0003L11.7182 22.0002L10.9725 21.9996C9.8471 21.9977 9.27672 21.9918 8.78397 21.9771L8.58989 21.9707C8.36564 21.9628 8.14444 21.9528 7.87778 21.9403C6.81361 21.8911 6.08861 21.7219 5.45028 21.4753C4.79194 21.2211 4.23444 20.8769 3.67861 20.3219C3.12278 19.7661 2.78028 19.2069 2.52528 18.5503C2.27778 17.9128 2.11028 17.1869 2.06028 16.1228C2.0484 15.8561 2.03871 15.6349 2.03086 15.4107L2.02457 15.2166C2.00994 14.7238 2.00327 14.1535 2.00111 13.0281L2.00098 10.9725C2.00284 9.8471 2.00879 9.27672 2.02346 8.78397L2.02981 8.58989C2.03778 8.36564 2.04778 8.14444 2.06028 7.87778C2.10944 6.81278 2.27778 6.08778 2.52528 5.45028C2.77944 4.79194 3.12278 4.23444 3.67861 3.67861C4.23444 3.12278 4.79278 2.78028 5.45028 2.52528C6.08778 2.27778 6.81278 2.11028 7.87778 2.06028C8.14444 2.0484 8.36564 2.03871 8.58989 2.03086L8.78397 2.02457C9.27672 2.00994 9.8471 2.00327 10.9725 2.00111L13.0281 2.00098ZM12.0003 7.00028C9.23738 7.00028 7.00028 9.23981 7.00028 12.0003C7.00028 14.7632 9.23981 17.0003 12.0003 17.0003C14.7632 17.0003 17.0003 14.7607 17.0003 12.0003C17.0003 9.23738 14.7607 7.00028 12.0003 7.00028ZM12.0003 9.00028C13.6572 9.00028 15.0003 10.3429 15.0003 12.0003C15.0003 13.6572 13.6576 15.0003 12.0003 15.0003C10.3434 15.0003 9.00028 13.6576 9.00028 12.0003C9.00028 10.3434 10.3429 9.00028 12.0003 9.00028ZM17.2503 5.50028C16.561 5.50028 16.0003 6.06018 16.0003 6.74943C16.0003 7.43867 16.5602 7.99944 17.2503 7.99944C17.9395 7.99944 18.5003 7.43954 18.5003 6.74943C18.5003 6.06018 17.9386 5.49941 17.2503 5.50028Z"></path></svg>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M22.2125 5.65605C21.4491 5.99375 20.6395 6.21555 19.8106 6.31411C20.6839 5.79132 21.3374 4.9689 21.6493 4.00005C20.8287 4.48761 19.9305 4.83077 18.9938 5.01461C18.2031 4.17106 17.098 3.69303 15.9418 3.69434C13.6326 3.69434 11.7597 5.56661 11.7597 7.87683C11.7597 8.20458 11.7973 8.52242 11.8676 8.82909C8.39047 8.65404 5.31007 6.99005 3.24678 4.45941C2.87529 5.09767 2.68005 5.82318 2.68104 6.56167C2.68104 8.01259 3.4196 9.29324 4.54149 10.043C3.87737 10.022 3.22788 9.84264 2.64718 9.51973C2.64654 9.5373 2.64654 9.55487 2.64654 9.57148C2.64654 11.5984 4.08819 13.2892 6.00199 13.6731C5.6428 13.7703 5.27232 13.8194 4.90022 13.8191C4.62997 13.8191 4.36771 13.7942 4.11279 13.7453C4.64531 15.4065 6.18886 16.6159 8.0196 16.6491C6.53813 17.8118 4.70869 18.4426 2.82543 18.4399C2.49212 18.4402 2.15909 18.4205 1.82812 18.3811C3.74004 19.6102 5.96552 20.2625 8.23842 20.2601C15.9316 20.2601 20.138 13.8875 20.138 8.36111C20.138 8.1803 20.1336 7.99886 20.1256 7.81997C20.9443 7.22845 21.651 6.49567 22.2125 5.65605Z"></path></svg>
                  </div>
                </div>
              </div>
              <div class="study__team">
                <div class="team__img">
                  <img src="../../../assets/team-2.webp" alt="Carlos Lázaro Borjas">
                </div>
                <div class="team__informartion">
                  <h4>Carlos Lázaro Borjas</h4>
                  <p>Ing. Industrial CIP N° 200314</p>
                  <div class="team__icons">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M14 13.5H16.5L17.5 9.5H14V7.5C14 6.47062 14 5.5 16 5.5H17.5V2.1401C17.1743 2.09685 15.943 2 14.6429 2C11.9284 2 10 3.65686 10 6.69971V9.5H7V13.5H10V22H14V13.5Z"></path></svg>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M13.0281 2.00098C14.1535 2.00284 14.7238 2.00879 15.2166 2.02346L15.4107 2.02981C15.6349 2.03778 15.8561 2.04778 16.1228 2.06028C17.1869 2.10944 17.9128 2.27778 18.5503 2.52528C19.2094 2.77944 19.7661 3.12278 20.3219 3.67861C20.8769 4.23444 21.2203 4.79278 21.4753 5.45028C21.7219 6.08694 21.8903 6.81361 21.9403 7.87778C21.9522 8.14444 21.9618 8.36564 21.9697 8.58989L21.976 8.78397C21.9906 9.27672 21.9973 9.8471 21.9994 10.9725L22.0002 11.7182C22.0003 11.8093 22.0003 11.9033 22.0003 12.0003L22.0002 12.2824L21.9996 13.0281C21.9977 14.1535 21.9918 14.7238 21.9771 15.2166L21.9707 15.4107C21.9628 15.6349 21.9528 15.8561 21.9403 16.1228C21.8911 17.1869 21.7219 17.9128 21.4753 18.5503C21.2211 19.2094 20.8769 19.7661 20.3219 20.3219C19.7661 20.8769 19.2069 21.2203 18.5503 21.4753C17.9128 21.7219 17.1869 21.8903 16.1228 21.9403C15.8561 21.9522 15.6349 21.9618 15.4107 21.9697L15.2166 21.976C14.7238 21.9906 14.1535 21.9973 13.0281 21.9994L12.2824 22.0002C12.1913 22.0003 12.0973 22.0003 12.0003 22.0003L11.7182 22.0002L10.9725 21.9996C9.8471 21.9977 9.27672 21.9918 8.78397 21.9771L8.58989 21.9707C8.36564 21.9628 8.14444 21.9528 7.87778 21.9403C6.81361 21.8911 6.08861 21.7219 5.45028 21.4753C4.79194 21.2211 4.23444 20.8769 3.67861 20.3219C3.12278 19.7661 2.78028 19.2069 2.52528 18.5503C2.27778 17.9128 2.11028 17.1869 2.06028 16.1228C2.0484 15.8561 2.03871 15.6349 2.03086 15.4107L2.02457 15.2166C2.00994 14.7238 2.00327 14.1535 2.00111 13.0281L2.00098 10.9725C2.00284 9.8471 2.00879 9.27672 2.02346 8.78397L2.02981 8.58989C2.03778 8.36564 2.04778 8.14444 2.06028 7.87778C2.10944 6.81278 2.27778 6.08778 2.52528 5.45028C2.77944 4.79194 3.12278 4.23444 3.67861 3.67861C4.23444 3.12278 4.79278 2.78028 5.45028 2.52528C6.08778 2.27778 6.81278 2.11028 7.87778 2.06028C8.14444 2.0484 8.36564 2.03871 8.58989 2.03086L8.78397 2.02457C9.27672 2.00994 9.8471 2.00327 10.9725 2.00111L13.0281 2.00098ZM12.0003 7.00028C9.23738 7.00028 7.00028 9.23981 7.00028 12.0003C7.00028 14.7632 9.23981 17.0003 12.0003 17.0003C14.7632 17.0003 17.0003 14.7607 17.0003 12.0003C17.0003 9.23738 14.7607 7.00028 12.0003 7.00028ZM12.0003 9.00028C13.6572 9.00028 15.0003 10.3429 15.0003 12.0003C15.0003 13.6572 13.6576 15.0003 12.0003 15.0003C10.3434 15.0003 9.00028 13.6576 9.00028 12.0003C9.00028 10.3434 10.3429 9.00028 12.0003 9.00028ZM17.2503 5.50028C16.561 5.50028 16.0003 6.06018 16.0003 6.74943C16.0003 7.43867 16.5602 7.99944 17.2503 7.99944C17.9395 7.99944 18.5003 7.43954 18.5003 6.74943C18.5003 6.06018 17.9386 5.49941 17.2503 5.50028Z"></path></svg>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M22.2125 5.65605C21.4491 5.99375 20.6395 6.21555 19.8106 6.31411C20.6839 5.79132 21.3374 4.9689 21.6493 4.00005C20.8287 4.48761 19.9305 4.83077 18.9938 5.01461C18.2031 4.17106 17.098 3.69303 15.9418 3.69434C13.6326 3.69434 11.7597 5.56661 11.7597 7.87683C11.7597 8.20458 11.7973 8.52242 11.8676 8.82909C8.39047 8.65404 5.31007 6.99005 3.24678 4.45941C2.87529 5.09767 2.68005 5.82318 2.68104 6.56167C2.68104 8.01259 3.4196 9.29324 4.54149 10.043C3.87737 10.022 3.22788 9.84264 2.64718 9.51973C2.64654 9.5373 2.64654 9.55487 2.64654 9.57148C2.64654 11.5984 4.08819 13.2892 6.00199 13.6731C5.6428 13.7703 5.27232 13.8194 4.90022 13.8191C4.62997 13.8191 4.36771 13.7942 4.11279 13.7453C4.64531 15.4065 6.18886 16.6159 8.0196 16.6491C6.53813 17.8118 4.70869 18.4426 2.82543 18.4399C2.49212 18.4402 2.15909 18.4205 1.82812 18.3811C3.74004 19.6102 5.96552 20.2625 8.23842 20.2601C15.9316 20.2601 20.138 13.8875 20.138 8.36111C20.138 8.1803 20.1336 7.99886 20.1256 7.81997C20.9443 7.22845 21.651 6.49567 22.2125 5.65605Z"></path></svg>
                  </div>
                </div>
              </div>
              <div class="study__team">
                <div class="team__img">
                  <img src="../../../assets/team-3.webp" alt="Jorge Prieta Menas">
                </div>
                <div class="team__informartion">
                  <h4>Jorge Prieta Mena</h4>
                  <p>Ing. Industrial</p>
                  <div class="team__icons">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M14 13.5H16.5L17.5 9.5H14V7.5C14 6.47062 14 5.5 16 5.5H17.5V2.1401C17.1743 2.09685 15.943 2 14.6429 2C11.9284 2 10 3.65686 10 6.69971V9.5H7V13.5H10V22H14V13.5Z"></path></svg>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M13.0281 2.00098C14.1535 2.00284 14.7238 2.00879 15.2166 2.02346L15.4107 2.02981C15.6349 2.03778 15.8561 2.04778 16.1228 2.06028C17.1869 2.10944 17.9128 2.27778 18.5503 2.52528C19.2094 2.77944 19.7661 3.12278 20.3219 3.67861C20.8769 4.23444 21.2203 4.79278 21.4753 5.45028C21.7219 6.08694 21.8903 6.81361 21.9403 7.87778C21.9522 8.14444 21.9618 8.36564 21.9697 8.58989L21.976 8.78397C21.9906 9.27672 21.9973 9.8471 21.9994 10.9725L22.0002 11.7182C22.0003 11.8093 22.0003 11.9033 22.0003 12.0003L22.0002 12.2824L21.9996 13.0281C21.9977 14.1535 21.9918 14.7238 21.9771 15.2166L21.9707 15.4107C21.9628 15.6349 21.9528 15.8561 21.9403 16.1228C21.8911 17.1869 21.7219 17.9128 21.4753 18.5503C21.2211 19.2094 20.8769 19.7661 20.3219 20.3219C19.7661 20.8769 19.2069 21.2203 18.5503 21.4753C17.9128 21.7219 17.1869 21.8903 16.1228 21.9403C15.8561 21.9522 15.6349 21.9618 15.4107 21.9697L15.2166 21.976C14.7238 21.9906 14.1535 21.9973 13.0281 21.9994L12.2824 22.0002C12.1913 22.0003 12.0973 22.0003 12.0003 22.0003L11.7182 22.0002L10.9725 21.9996C9.8471 21.9977 9.27672 21.9918 8.78397 21.9771L8.58989 21.9707C8.36564 21.9628 8.14444 21.9528 7.87778 21.9403C6.81361 21.8911 6.08861 21.7219 5.45028 21.4753C4.79194 21.2211 4.23444 20.8769 3.67861 20.3219C3.12278 19.7661 2.78028 19.2069 2.52528 18.5503C2.27778 17.9128 2.11028 17.1869 2.06028 16.1228C2.0484 15.8561 2.03871 15.6349 2.03086 15.4107L2.02457 15.2166C2.00994 14.7238 2.00327 14.1535 2.00111 13.0281L2.00098 10.9725C2.00284 9.8471 2.00879 9.27672 2.02346 8.78397L2.02981 8.58989C2.03778 8.36564 2.04778 8.14444 2.06028 7.87778C2.10944 6.81278 2.27778 6.08778 2.52528 5.45028C2.77944 4.79194 3.12278 4.23444 3.67861 3.67861C4.23444 3.12278 4.79278 2.78028 5.45028 2.52528C6.08778 2.27778 6.81278 2.11028 7.87778 2.06028C8.14444 2.0484 8.36564 2.03871 8.58989 2.03086L8.78397 2.02457C9.27672 2.00994 9.8471 2.00327 10.9725 2.00111L13.0281 2.00098ZM12.0003 7.00028C9.23738 7.00028 7.00028 9.23981 7.00028 12.0003C7.00028 14.7632 9.23981 17.0003 12.0003 17.0003C14.7632 17.0003 17.0003 14.7607 17.0003 12.0003C17.0003 9.23738 14.7607 7.00028 12.0003 7.00028ZM12.0003 9.00028C13.6572 9.00028 15.0003 10.3429 15.0003 12.0003C15.0003 13.6572 13.6576 15.0003 12.0003 15.0003C10.3434 15.0003 9.00028 13.6576 9.00028 12.0003C9.00028 10.3434 10.3429 9.00028 12.0003 9.00028ZM17.2503 5.50028C16.561 5.50028 16.0003 6.06018 16.0003 6.74943C16.0003 7.43867 16.5602 7.99944 17.2503 7.99944C17.9395 7.99944 18.5003 7.43954 18.5003 6.74943C18.5003 6.06018 17.9386 5.49941 17.2503 5.50028Z"></path></svg>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M22.2125 5.65605C21.4491 5.99375 20.6395 6.21555 19.8106 6.31411C20.6839 5.79132 21.3374 4.9689 21.6493 4.00005C20.8287 4.48761 19.9305 4.83077 18.9938 5.01461C18.2031 4.17106 17.098 3.69303 15.9418 3.69434C13.6326 3.69434 11.7597 5.56661 11.7597 7.87683C11.7597 8.20458 11.7973 8.52242 11.8676 8.82909C8.39047 8.65404 5.31007 6.99005 3.24678 4.45941C2.87529 5.09767 2.68005 5.82318 2.68104 6.56167C2.68104 8.01259 3.4196 9.29324 4.54149 10.043C3.87737 10.022 3.22788 9.84264 2.64718 9.51973C2.64654 9.5373 2.64654 9.55487 2.64654 9.57148C2.64654 11.5984 4.08819 13.2892 6.00199 13.6731C5.6428 13.7703 5.27232 13.8194 4.90022 13.8191C4.62997 13.8191 4.36771 13.7942 4.11279 13.7453C4.64531 15.4065 6.18886 16.6159 8.0196 16.6491C6.53813 17.8118 4.70869 18.4426 2.82543 18.4399C2.49212 18.4402 2.15909 18.4205 1.82812 18.3811C3.74004 19.6102 5.96552 20.2625 8.23842 20.2601C15.9316 20.2601 20.138 13.8875 20.138 8.36111C20.138 8.1803 20.1336 7.99886 20.1256 7.81997C20.9443 7.22845 21.651 6.49567 22.2125 5.65605Z"></path></svg>
                  </div>
                </div>
              </div>
            </div>
            <div class="button-download">
              <a href="https://www.ipssoma.com/iniciar-sesion" class="button download-pdf">¡Comprar Ahora!</a>
            </div>
          </div> -->
          <div class="study__content-information contents">
            <dl>
              <dt>PASO 1:</dt>
              <dd>Registrarse en el siguiente link: <a href="https://www.ipssoma.com/iniciar-sesion"><b>https://www.ipssoma.com/iniciar-sesion</b></a></dd>
              <dt>PASO 2:</dt>
              <dd>Realizar el Pagó del <strong><b>curso/diplomado</b></strong>.</dd>
              <dt>PASO 3:</dt>
              <dd>Enviar al correo <a href="mailto:ippsoma1@gmail.com"><b>ipssoma1@gmail.com</b></a>  los datos personales y la foto del baucher de pago.</dd>
            </dl>
            <div class="button-download">
              <a href="https://www.ipssoma.com/iniciar-sesion" class="button download-pdf">¡Comprar Ahora!</a>
            </div>
          </div>
          <div class="study__content-information contents">
            <div class="study__bancos-information">
              <div class="study__bancos">
                <img src="../../../assets/scotiabank-logo.webp" alt="Logo de Scotiabank">
                <img src="../../../assets/bancodelanacio-logo.webp" alt="Logo de Banco de la Nación">
                <img src="../../../assets/bbva-logo.webp" alt="Logo de BBVA">
                <img src="../../../assets/bcp-logo.webp" alt="Logo de BCP">
                <img src="../../../assets/yape-logo.webp" alt="Logo de Yape">
              </div>
              <dl class="study__information">
                <dt>1. Scotiabank</dt>
                <dd>
                  <ul>
                    <li>Instituto Peruano SSOMA</li>
                    <li>Cta. 2070439787</li>
                    <li>RUC 20608464094</li>
                    <li>CCI: 00901720207043978752 </li>
                  </ul>
                </dd>
                <dt>2. Banco de la Nación</dt>
                <dd>
                  <ul>
                    <li>Instituto Peruano SSOMA</li>
                    <li>Cta. De Ahorro 04-049-508072</li>
                    <li>RUC 20608464094</li>
                  </ul>
                </dd>
                <dt>3. BBVA</dt>
                <dd>
                  <ul>
                    <li>Instituto Peruano SSOMA</li>
                    <li>Cta CTE. 001107910100034907</li>
                    <li>RUC 20608464094</li>
                  </ul>
                </dd>
                <dt>4. BCP</dt>
                <dd>
                  <ul>
                    <li>Instituto Peruano SSOMA</li>
                    <li>Cta Corriente 193-9847932-0-58</li>
                    <li>RUC 20608464094</li>
                    <li>CCI: 00219300984793205816</li>
                  </ul>
                </dd>
                <dt>5. YAPE</dt>
                <dd>
                  <ul>
                    <li>Instituto Peruano SSOMA</li>
                    <li>+51 917 067 350</li>
                  </ul>
                </dd>
                <div class="button-download">
                  <a href="https://www.ipssoma.com/iniciar-sesion" class="button download-pdf">¡Comprar Ahora!</a>
                </div>
              </dl>
            </div>
          </div>
          <div class="study__content-information contents">
            <dl>
              <dt>1. ¿Necesito tener una carrera o ser ingeniero para cursar este Dimplomado?</dt>
              <dd>R: No, no es necesario tener estudios previos. Si no tienes estudios universitarios o secundarios y no tienes experiencia laboral, este diplomado es para ti.</dd>
              <dt>2. ¿Cuál es el horario de estudio?</dt>
              <dd>R: Tendrás acceso a las aulas las 24 horas del día durantetodo el trayecto de tu formación. Además, contarás con unatutoría académica cada semana vía Zoom.</dd>
              <dt>3. ¿Puedo conseguir trabajo tan solo con sus certificaciones?</dt>
              <dd>R: Tendrás todas las herramientas necesarias para queconsigas un trabajo como profesional en Prevención deRiesgos; todo dependerá la aplicación de esas herramientas.</dd>
              <dt>4. ¿Las certificaciones tiene fecha de vencimiento?</dt>
              <dd>R: No, no tienen fecha de vencimiento. En caso de que una ley se actualice, será recomendable su actualización profesional. Sin embargo, el certificado seguirá siendo válido para la ley, reglamento o norma estudiada.</dd>
              <dt>5. ¿Qué me garantiza que son una empresa confiable?</dt>
              <dd>R: Somos una empresa jurídicamente constituida, con su RUC activo y orientada a la formación y capacitación profesional con más de 7 mil egresados a nivel nacional e internacional.</dd>
              <dt>6. ¿Cuántas horas de crédito tiene el diplomado?</dt>
              <dd>R: Las horas créditos las calcula el ente rector donde te postulas para el puesto de trabajo, según el valor que él le asigne a la categoría ‘diplomado’.</dd>
              <div class="button-download">
                <a href="https://www.ipssoma.com/iniciar-sesion" class="button download-pdf">¡Comprar Ahora!</a>
              </div>
            </dl>
          </div>
        </div>
      </div>
      </div>
      <div class="course">
      <h2 class="course__subtitle">Recomendaciones</h2>
      <div class="course__courses">
        <div data-v-7392a08e="" class="my-5 cursor-pointer"><div data-v-521d5756="" data-v-7392a08e="" class="py-1"><div data-v-521d5756="" title="Prevencionista en seguridad y salud en el trabajo" class="course-card my-5"><div data-v-521d5756="" style="border-top-left-radius: 15px; border-top-right-radius: 15px;"><img data-v-521d5756="" src="https://ipssoma-storage.s3.eu-west-1.amazonaws.com/curso diplomado/1/portada/4.webp" alt="https://ipssoma-storage.s3.eu-west-1.amazonaws.com/curso diplomado/1/portada/4.webp" class="card-img-top border-radius-image"></div><div data-v-521d5756="" class="content p-2"><div data-v-521d5756="" class="row"><div data-v-521d5756="" class="col-md-12 col-lg-12 col-sm-12 col-xs-12 py-4 mb-1 content-overflow"><p data-v-521d5756="" class="text-left text-capitalize course-title"> Prevencionista en seguridad y salud en el trabajo </p></div><div data-v-521d5756="" class="row pl-4"><div data-v-521d5756="" class="col-md-11 ml-1" style="background: rgb(19, 27, 30); border-bottom-left-radius: 15px; border-bottom-right-radius: 15px;"><strong data-v-521d5756="" class="text-left" style="color: white;"> S/. 520 </strong><strong data-v-521d5756=""><button data-v-521d5756="" class="btn bg-primary-pl btn-sm float-right" style="border-radius: 15px; font-weight: 700;"> Información </button></strong><br data-v-521d5756=""></div></div></div></div></div></div></div>
        <div data-v-7392a08e="" class="my-5 cursor-pointer"><div data-v-521d5756="" data-v-7392a08e="" class="py-1"><div data-v-521d5756="" title="Prevencionista en Seguridad y Salud Ocupacional Sector Construcción" class="course-card my-5"><div data-v-521d5756="" style="border-top-left-radius: 15px; border-top-right-radius: 15px;"><img data-v-521d5756="" src="https://ipssoma-storage.s3.eu-west-1.amazonaws.com/curso diplomado/2/portada/1.webp" alt="https://ipssoma-storage.s3.eu-west-1.amazonaws.com/curso diplomado/2/portada/1.webp" class="card-img-top border-radius-image"></div><div data-v-521d5756="" class="content p-2"><div data-v-521d5756="" class="row"><div data-v-521d5756="" class="col-md-12 col-lg-12 col-sm-12 col-xs-12 py-4 mb-1 content-overflow"><p data-v-521d5756="" class="text-left text-capitalize course-title"> Prevencionista en Seguridad y Salud Ocupacional Sector Construcción </p></div><div data-v-521d5756="" class="row pl-4"><div data-v-521d5756="" class="col-md-11 ml-1" style="background: rgb(19, 27, 30); border-bottom-left-radius: 15px; border-bottom-right-radius: 15px;"><strong data-v-521d5756="" class="text-left" style="color: white;"> S/. 510 </strong><strong data-v-521d5756=""><button data-v-521d5756="" class="btn bg-primary-pl btn-sm float-right" style="border-radius: 15px; font-weight: 700;"> Información </button></strong><br data-v-521d5756=""></div></div></div></div></div></div></div>
        <div data-v-7392a08e="" class="my-5 cursor-pointer"><div data-v-521d5756="" data-v-7392a08e="" class="py-1"><div data-v-521d5756="" title="Supervisor en trabajos de alto riesgo" class="course-card my-5"><div data-v-521d5756="" style="border-top-left-radius: 15px; border-top-right-radius: 15px;"><img data-v-521d5756="" src="https://ipssoma-storage.s3.eu-west-1.amazonaws.com/curso normal/3/portada/2.webp" alt="https://ipssoma-storage.s3.eu-west-1.amazonaws.com/curso normal/3/portada/2.webp" class="card-img-top border-radius-image"></div><div data-v-521d5756="" class="content p-2"><div data-v-521d5756="" class="row"><div data-v-521d5756="" class="col-md-12 col-lg-12 col-sm-12 col-xs-12 py-4 mb-1 content-overflow"><p data-v-521d5756="" class="text-left text-capitalize course-title"> Supervisor en trabajos de alto riesgo </p></div><div data-v-521d5756="" class="row pl-4"><div data-v-521d5756="" class="col-md-11 ml-1" style="background: rgb(19, 27, 30); border-bottom-left-radius: 15px; border-bottom-right-radius: 15px;"><strong data-v-521d5756="" class="text-left" style="color: white;"> S/. 420 </strong><strong data-v-521d5756=""><button data-v-521d5756="" class="btn bg-primary-pl btn-sm float-right" style="border-radius: 15px; font-weight: 700;"> Información </button></strong><br data-v-521d5756=""></div></div></div></div></div></div></div>
      </div>
    </div>
    </section>
  </main>
</template>
<style lang="scss">

/* ------ COLORS ------ */
$title-color: #FFB100;
$text-color: #332C39;
$strong-color: #080202;
$card-background: #282A3A;
$card-color: #EEEEEE;

/* ------ FONT SIZE ------ */
  $h1-fs-mobile: 9cqw;
  $h2-fs-mobile: 1.125rem;
  $h3-fs-mobile: 1rem;
  $h4-fs-moile: .875rem;
  $text-fs-mobile: 1rem;

  // $h1-fs-desktop: 4rem;
  // $h2-fs-desktop: 2.5rem;
  // $h3-fs-desktop: 1rem;
  // $text-fs-desktop: 1.125rem;

/* ------ BASE ------ */
* {
  box-sizing: border-box;
}

h1,
h2,
h3,
h4,
p{
  margin: .313rem 0rem;
}

h1 {
  color: $title-color;
  font-size: $h1-fs-mobile;
  font-weight: 900;
  line-height: 1.3;
}

h2,
h3 {
  color: $text-color;
  font-size: 1rem;
  font-weight: 500;
}

h4 {
  color: $title-color;
  font-size: $h4-fs-moile;
  font-weight: bold;
}

p{
  color: $text-color;
  font-weight: 400;
  line-height: 1.7;
}

a{
  color: $strong-color;
}

ul{
  margin-bottom: 0rem;
}

strong {
  color: $strong-color;
}

video{
  max-width: 100%;
}

/* ------ REPEAT CLASES ------ */
section {
  padding: 3.125rem 1rem;
}

.grid {
  display: grid;
  gap: 1.875rem;
}

.main .button {
  padding: .625rem .938rem;
  background-color: $title-color;
  color: $strong-color;
  font-size: $h4-fs-moile;
  font-weight: bold;
}

// HERO
.hero {
  padding: 0rem 1rem 3.125rem;
  & .hero__list {
    color: $strong-color;
    font-weight: 500;
    list-style-type: '- ';
    padding-left: .625rem;
    margin: .625rem 0;
  }

  &__list span {
    color: $text-color;
    font-weight: 400;
  }

  &__buttons {
    display: flex;
    flex-wrap: wrap;
    gap: .625rem;
  }

  & .button--2 {
    background-color: transparent;
    border: 1px solid;
  }

  &__cards {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: 1.25rem;
  }

  &__card {
    width: 250px;
    height: 180px;
    padding: 1.5rem 1.25rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: $card-background;
    border-radius: 20px;
  }

  &__icon {
    fill: $title-color;
    width: 42px;
    height: 42px;
    margin-bottom: 10px;
  }

  & h4 {
    margin-top: 5px;
  }

  &__card span {
    color: $card-color;
    font-size: .75rem;
    font-weight: 400;
    text-align: center;
  }
}

.study{
  width: 100%;
  overflow: hidden;
  &__subtitle{
    font-size: $h2-fs-mobile;
  }
  & .study__tab{
    padding: .5rem 0rem 0rem 0rem;
    position: relative;
  }
  &__tab{
    width: 95vw;
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    white-space: nowrap;
    overflow-x: scroll;
    list-style: none;
  }
  &__tab::-webkit-scrollbar{
    height: 0px;
  }
  &__title-tab{
    color: #5A5A5A;
    font-weight: 500;
    cursor: pointer;
  }
  &__subtitle{
    color: $text-color;
    font-size: 1.125rem;
  }
  &__item{
    display: flex;
    align-items: center;
  }
  &__content{
    background-color: #ffffff;
    padding: 1rem;
  }
  &__content-information dt{
    color: $text-color;
    font-weight: 700;
    margin: .313rem 0rem;
  }
  &__content-information dd{
    margin-bottom: 1.25rem;
  }
  &__content-information p, li{
    margin: .313rem 0rem 0rem 0rem;
  }
  &__content-information ul, ol{
    padding-left: 0rem;
  }
  &__content-information li{
    list-style-type: '';
  }
  &__content-information:nth-child(2) li{
    color: $text-color;
    list-style-type: '';
  }
  &__content-information:first-child svg{
    width: 24px;
    height: 24px;
  }
  & dd strong, em{
    font-style: normal;
    font-weight: 400;
  }
  & .em--diferent, .em--diferent-li{
    font-style: italic;
  }
  &__teams{
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 2rem;
  }
  &__team{
    width: 280px;
    height: 400px;
  }
  &__bancos{
    display: none;
  }
}

.course{
  margin-top: 3rem;
  &__subtitle{
    color: $strong-color;
    font-size: $h2-fs-mobile;
  }
  &__courses{
    display: flex;
    justify-content: center;
    gap: 2rem;
    flex-wrap: wrap;
  }
  &-card{
    width: 280px;
  }
}

.button-download{
  display: flex;
  margin-top: 1rem;
}

.download-pdf{
  display: flex;
  gap: .5rem;
  flex-basis: content;
  align-items: center;
}

.team__img img{
  width: 280px;
  height: auto;
}

.team__informartion{
  padding: 1rem;
  text-align: center;
  height: 160px;
  background-color: $title-color;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}

.team__informartion h4{
  color: $strong-color;
  font-size: 1.125rem;
}

.team__informartion p{
  color: #5A5A5A;
  font-size: .875rem;
  font-weight: 500;
  text-align: center;
}

.team__icons{
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: .625rem;
}

.team__icons svg{
  width: 42px;
  height: 42px;
  padding: .5rem;
  background-color: white;
  color: #1A1A1A;
  border-radius: 50%;
  cursor: pointer;
}

.team__icons svg:hover{
  background-color: #EEEEEE;
}

.line{
  position: absolute;
  bottom: 0;
  left: 0;
  width: 170px;
  height: 3px;
  background-color: $strong-color;
  transition: all .3s ease-in-out;
  z-index: 10;
}

.line--2{
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100vmax;
  height: 3px;
  background-color: #CCCCCC;
}

.contents {
  display: none;
}

.active-tab{
  padding: .5rem .5rem .5rem 1rem;
  background-color: #ffffff;
}

.active-tab .study__title-tab{
  color: $strong-color;
  font-weight: 700;
}

.contents.active-content {
  display: block;
}

/* ------ RESPONSIVE ------ */
@media screen and (min-width: 450px){
  .hero{
    &__titles h1{
      font-size: 2.375rem;
    }
  }
}

@media screen and (min-width: 568px){
  .hero{
    &__titles h1{
      font-size: 6.5cqw;
    }
  }
}

@media screen and (min-width: 768px){
  .hero{
    &__titles h1{
      max-width: 750px;
      font-size: 3.125rem;
    }
    &__titles h2, h3{
      font-size: 1.125rem;
    }
    &__list{
      line-height: 1.8;
    }
    &__list li, .heor__list span{
      font-size: 1.125rem;
    }
    &__video{
      display: flex;
      justify-content: center;
    }
    &__video video{
      max-width: 700px;
    }
  }
  .main .button{
    font-size: 1rem;
  }
  .study{
    &__subtitle{
      font-size: 1.5rem;
    }
    &__bancos{
      max-width: 500px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      gap: 1.5rem;
      flex-basis: content;
    }
    &__bancos-information{
      display: grid;
      grid-template-columns: 1fr 2fr;
    }
    &__information{
      grid-column: 1 / 2;
      grid-row: 1 / 2;
    }
  }
  .course{
    &__subtitle{
      font-weight: 700;
      font-size: 1.5rem;
    }
  }
}

@media screen and (min-width: 1024px){
  .main{
    padding: 0rem 1rem;
  }
  .section{
    padding: 3.125rem 0rem;
  }
  .hero{
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr;
    justify-content: center;
    align-items: center;
    row-gap: 3.75rem;
    &__titles h1{
      font-size: 3rem;
      font-weight: 700;
    }
    &__information{
      grid-column: 1 / 2;
      grid-row: 1 / 2;
    }
    &__buttons{
      gap: 2rem;
    }
    &__buttons .button:first-child{
      background-color: $title-color;
      transition: background-color .2s ease-out 100ms;
      border: $title-color 1px solid;
    }
    &__buttons .button:first-child:hover{
      background-color: white;
      border:  1px solid;
    }
    &__buttons .button:last-child:hover{
      background-color: $title-color;
      transition: $card-background 3s esae-out 100ms;
      border: $title-color 1px solid;
    }
    &__cards{
      grid-column: 1 / 3;
      max-width: 100%;
    }
    &__video video{
      max-width: 100%;
    }
  }

  .study{
    &__tab-content{
      max-width: 1200px;
    }
    &__tab{
      width: 100%;
      justify-content: flex-start;
    }
    &__title-tab:hover{
      color: $strong-color;
      transition: all .3s;
    }
    &__teams{
      justify-content: flex-start;
    }
  }
  .course{
    &__courses{
      justify-content: flex-start;
    }
  }
  .button-download{
    display: flex;
    margin-top: 2rem;
  }
  .button-download a:hover{
    background-color: white;
    border:  1px solid;
  }
}

@media screen and (min-width:1400px){
  .hero{
    &__cards{
      gap: 4rem;
    }
    &__card{
      display: flex;
      flex-direction: column;
      padding: 1.5rem 1rem;
      justify-content: flex-start;
      width: 280px;
      height: 190px;
    }
    &__icon{
      width: 48px;
      height: 48px;
    }
    & h4{
      font-size: 1rem;
    }
    &__card span{
      font-size: .875rem;
    }
  }
  .study{
    display: flex;
    justify-content: space-evenly;
    column-gap: 2rem;
    &__tab-content{
      width: 1000px;
    }
  }
  .course{
    margin-top: 0rem;
    &__courses{
      max-width: 300px;
    }
  }
}

@media screen and (min-width: 1600px){
  .main .button{
    font-size: 1.125rem;
  }
  .line{
    width: 190px;
  }
  .hero{
    grid-template-columns: 700px 800px;
    &__titles h2, h3{
      font-size: 1.25rem;
    }
  }
  .study{
    &__subtitle{
      font-size: 1.75rem;
    }
    &__title-tab{
      font-size: 1.125rem;
    }
    &__tab-content{
      width: 1200px;
    }
  }
  .course{
    &__subtitle{
      font-size: 1.75rem;
    }
  }
}

@media screen and (min-width: 1700px){
  .hero{
    grid-template-columns: 700px 900px;
  }
}

</style>
<script>
export default {
  data(){
    return{
      lists: ['Malla Curricular', 'Requisitos de Inscripción', 'Medios de Pago', 'Preguntas Frecuentes'],
    }
  },
  mounted() {
    const items = document.querySelectorAll('.items');
    const contents = document.querySelectorAll('.contents');

    items.forEach((item, index) => {
      item.addEventListener('click', (e) => {
        items.forEach(item => { item.classList.remove('active-tab') });
        item.classList.add('active-tab');

        let line = document.querySelector('.line');
        line.style.width = e.target.offsetWidth + 'px';
        line.style.left = e.target.offsetLeft + 'px';

        contents.forEach(content => { content.classList.remove('active-content') });
        contents[index].classList.add('active-content');
      })
    })
  }
  // methods:{
  //   test(){
  //     alert()
  //   }
  // }
}
</script>